import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EntityManager, IEntity } from '@proximus/entity-manager';
import { OptionLockConfigEntity } from '../configs/entity.config';
import { BrandService } from './brand.service';

@Injectable({
  providedIn: 'root',
})
export class OptionLockService {
  constructor(private brandService: BrandService) {}

  lockOption(mpcUuid: any, plc, serviceId): Observable<IEntity<any>> {
    const appBrand = this.brandService.getAppBrandValue();
    const params = {
      optionMpcUuid: mpcUuid,
      plc,
      serviceId,
      appBrand,
    };

    const iEntity = EntityManager.createEntity(OptionLockConfigEntity, params);
    return EntityManager.saveEntity(iEntity);
  }
}
